module.exports = __webpack_public_path__ + "img/trash.759539b4.svg";